import React, { useState } from 'react';
import { image } from 'cademy-shared-web';
import { Environment } from 'services/Environment';

export const Img = ({
    src = '',
    size = '800',
    alt = 'Uploaded media thumbnail',
    fallback = undefined,
    ...props
}) => {
    const [error, setError] = useState(false);

    const genImgLink = () => {
        if (error) return fallback || src;
        if (src) return `${image.getBaseUrl(src)}w${size}.webp`;
        return fallback;
    };

    return (
        <img
            src={`${Environment.ASSETS_URL}/images/placeholder.jpg`}
            srcSet={genImgLink()}
            onError={() => setError(true)}
            alt={alt}
            className="lazyload"
            {...props}
        />
    );
};

export const CourseImage = ({
    course: { name, educator, educator_ref, img_urls, autoimg },
    className,
    size = 600,
}) => {
    const [error, setError] = useState(false);

    if (img_urls?.length > 0) {
        if (error) {
            return (
                <picture className={className}>
                    <Img
                        src={img_urls[0]}
                        alt={
                            name +
                            ' by ' +
                            ((educator && educator.name) || educator_ref) +
                            ' cademy course thumbnail'
                        }
                    />
                </picture>
            );
        }

        return (
            <picture className={className}>
                <source
                    type="image/webp"
                    data-src={`${image.getBaseUrl(img_urls[0])}w${size}.webp 2x`}
                    data-srcset={`${image.getBaseUrl(img_urls[0])}w${size / 2}.webp 1x, ${image.getBaseUrl(img_urls[0])}w${size}.webp 2x`}
                />
                <source data-srcset={image.getFallbackUrl(img_urls[0])} />
                <img
                    src={`${Environment.ASSETS_URL}/images/placeholder.jpg`}
                    data-src={image.getFallbackUrl(img_urls[0])}
                    className="lazyload"
                    alt={
                        name +
                        ' by ' +
                        ((educator && educator.name) || educator_ref) +
                        ' cademy course thumbnail'
                    }
                    onError={() => setError(true)}
                />
            </picture>
        );
    }

    if (autoimg) {
        return (
            <picture className={className}>
                <img className="lazyload" data-src={autoimg.url} alt="Autogenerated thumbnail" />
            </picture>
        );
    }

    return (
        <picture className={className}>
            <img
                className="lazyload"
                data-src="https://images.unsplash.com/photo-1503676260728-1c00da094a0b?ixlib=rb-1.2.1&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1080&fit=max&ixid=eyJhcHBfaWQiOjExODk3Mn0"
                alt="Autogenerated thumbnail"
            />
        </picture>
    );
};
